import { ExtendedFieldsSourceType } from "us.collection.admin/constants";
import { ExtendedFieldDataTypes } from "us.common/constants";

export function SaveExtendedField(this: any): any {
  return {
    id: this.id,
    fieldName: this.fieldName,
    fieldCategory: this.fieldCategory,
    description: this.description ? this.description : "",
    dataTypeId: this.dataTypeId,
    dataType: this.dataType,
    valueType:
      this.dataType?.trim()?.toLowerCase() == ExtendedFieldDataTypes.CUSTOM
        ? this.valueType
        : undefined,
    valueSource:
      this.dataType?.trim()?.toLowerCase() == ExtendedFieldDataTypes.CUSTOM
        ? this.valueType == ExtendedFieldsSourceType.SP
          ? this.storedProcedure
          : this.valueList?.join(",")
        : undefined,
  };
}
